export interface Video {
  id: string;
  title: string;
  slug: string;
  category: string;
  thumbnail: string;
  duration: string;
  rating: number;
  quality: string;
  year: number;
  description: string;
  tags: string[];
  views: number;
  featured: boolean;
}

export const categories = [
  { slug: 'dongzuo', name: '动作片', icon: 'ri-sword-line' },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-laugh-line' },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line' },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line' },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line' },
  { slug: 'jilu', name: '纪录片', icon: 'ri-film-line' },
  { slug: 'donghua', name: '动画片', icon: 'ri-palette-line' },
  { slug: 'juqing', name: '剧情片', icon: 'ri-movie-2-line' },
  { slug: 'xuanyi', name: '悬疑片', icon: 'ri-search-eye-line' },
  { slug: 'zhanzheng', name: '战争片', icon: 'ri-shield-flash-line' },
];

export const videos: Video[] = [
  {
    id: 'v1',
    title: '龙虎风云',
    slug: 'longhu-fengyun',
    category: 'dongzuo',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20action%20martial%20arts%20film%20poster%20style%20with%20dramatic%20lighting%20two%20fighters%20facing%20off%20in%20rain%20cinematic%20composition%20warm%20golden%20tones%20against%20dark%20moody%20background%20film%20grain%20texture%20movie%20poster%20aesthetic&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    duration: '98分钟',
    rating: 8.7,
    quality: '蓝光',
    year: 1991,
    description: '一部经典的国产动作影片，讲述了正义与邪恶之间的激烈对抗。影片情节紧凑，武打场面精彩绝伦，演员表演入木三分，展现了九十年代国产动作片的巅峰水准。',
    tags: ['动作', '警匪', '经典'],
    views: 1250000,
    featured: true,
  },
  {
    id: 'v2',
    title: '阳光灿烂的日子',
    slug: 'yangguang-canlan',
    category: 'juqing',
    thumbnail: 'https://readdy.ai/api/search-image?query=nostalgic%20Chinese%20youth%20film%20aesthetic%20warm%20sunlight%20through%20leaves%20group%20of%20teenagers%20laughing%20in%20alley%20retro%201990s%20Beijing%20atmosphere%20golden%20hour%20cinematic%20photography%20film%20poster%20style&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    duration: '134分钟',
    rating: 9.1,
    quality: '超清',
    year: 1994,
    description: '一部关于青春与成长的电影，通过对少年时代的美好回忆，展现了那个特殊年代年轻人的梦想与迷茫。影片充满诗意与浪漫，是国产文艺片的瑰宝。',
    tags: ['剧情', '青春', '文艺'],
    views: 980000,
    featured: true,
  },
  {
    id: 'v3',
    title: '大决战之辽沈战役',
    slug: 'dajuezhan-liaoshen',
    category: 'zhanzheng',
    thumbnail: 'https://readdy.ai/api/search-image?query=epic%20Chinese%20war%20film%20battlefield%20scene%20with%20soldiers%20in%20formation%20smoke%20and%20fire%20dramatic%20sky%20historical%20military%20cinematic%20composition%20grand%20scale%20movie%20poster%20aesthetic%20warm%20sepia%20tones&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    duration: '210分钟',
    rating: 8.9,
    quality: '蓝光',
    year: 1991,
    description: '史诗级战争巨制，恢弘再现解放战争中的辽沈战役。影片以宏大的战争场面和细腻的人物刻画，展现了那段波澜壮阔的历史画卷。',
    tags: ['战争', '历史', '史诗'],
    views: 1560000,
    featured: true,
  },
  {
    id: 'v4',
    title: '霸王别姬',
    slug: 'bawang-bieji',
    category: 'juqing',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20Peking%20opera%20film%20aesthetic%20two%20performers%20in%20elaborate%20traditional%20costumes%20and%20makeup%20on%20stage%20dramatic%20red%20and%20gold%20lighting%20artistic%20composition%20cinematic%20photography%20cultural%20heritage&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    duration: '171分钟',
    rating: 9.6,
    quality: '蓝光',
    year: 1993,
    description: '华语电影史上的不朽经典，讲述了两位京剧伶人跨越半个世纪的悲欢离合。影片融合了中国传统文化与人性深度探索，被誉为中国电影的巅峰之作。',
    tags: ['剧情', '经典', '文艺'],
    views: 3200000,
    featured: true,
  },
  {
    id: 'v5',
    title: '纵横四海',
    slug: 'zongheng-sihai',
    category: 'dongzuo',
    thumbnail: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20heist%20action%20film%20style%20three%20stylish%20thieves%20in%20elegant%20attire%20with%20cityscape%20backdrop%20dramatic%20lighting%20golden%20warm%20tones%20cinematic%20composition%20classic%201990s%20movie%20poster%20vibe&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    duration: '108分钟',
    rating: 8.8,
    quality: '超清',
    year: 1991,
    description: '一部充满浪漫主义色彩的动作冒险片，讲述了三名盗贼的传奇故事。影片风格独特，动作设计华丽精彩，是港产动作片的经典代表作。',
    tags: ['动作', '冒险', '经典'],
    views: 2100000,
    featured: false,
  },
  {
    id: 'v6',
    title: '少林寺',
    slug: 'shaolin-si',
    category: 'dongzuo',
    thumbnail: 'https://readdy.ai/api/search-image?query=Shaolin%20temple%20martial%20arts%20film%20scene%20monks%20training%20in%20ancient%20courtyard%20with%20traditional%20architecture%20warm%20sunset%20light%20cinematic%20composition%20Chinese%20kung%20fu%20movie%20poster%20style%20epic%20and%20spiritual&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    duration: '100分钟',
    rating: 8.5,
    quality: '超清',
    year: 1982,
    description: '一部影响深远的功夫电影经典，讲述少林武僧保家卫国的故事。影片中真实的武术表演和震撼的打斗场面，让世界认识了中国功夫的魅力。',
    tags: ['动作', '功夫', '经典'],
    views: 2800000,
    featured: false,
  },
  {
    id: 'v7',
    title: '倩女幽魂',
    slug: 'qiannv-youhun',
    category: 'kongbu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20ghost%20fantasy%20film%20aesthetic%20ethereal%20beautiful%20female%20ghost%20in%20flowing%20white%20robes%20in%20ancient%20temple%20moonlight%20mystical%20blue%20atmosphere%20cinematic%20composition%20romantic%20horror%20film%20poster&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    duration: '96分钟',
    rating: 8.8,
    quality: '蓝光',
    year: 1987,
    description: '经典奇幻爱情鬼片，讲述书生与女鬼之间凄美的爱情故事。影片画面唯美，音乐动人，是中国奇幻电影的里程碑之作。',
    tags: ['奇幻', '爱情', '经典'],
    views: 1900000,
    featured: false,
  },
  {
    id: 'v8',
    title: '喜剧之王',
    slug: 'xiju-zhiwang',
    category: 'xiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20comedy%20film%20scene%20man%20rehearsing%20dramatic%20acting%20in%20front%20of%20mirror%20in%20small%20apartment%20warm%20lighting%20nostalgic%201990s%20aesthetic%20cinematic%20photography%20humorous%20and%20heartwarming%20movie%20poster&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    duration: '85分钟',
    rating: 8.6,
    quality: '超清',
    year: 1999,
    description: '一部笑中带泪的经典喜剧，讲述了一位龙套演员追逐梦想的故事。影片以幽默的方式展现了小人物的坚持与奋斗，感动了无数观众。',
    tags: ['喜剧', '励志', '经典'],
    views: 3100000,
    featured: false,
  },
  {
    id: 'v9',
    title: '黄飞鸿之男儿当自强',
    slug: 'huangfeihong-naner',
    category: 'dongzuo',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20hero%20film%20man%20in%20traditional%20Chinese%20clothing%20performing%20kung%20fu%20pose%20at%20sunset%20with%20Chinese%20architecture%20background%20dramatic%20golden%20lighting%20epic%20cinematic%20composition%20heroic%20movie%20poster&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    duration: '120分钟',
    rating: 8.4,
    quality: '蓝光',
    year: 1992,
    description: '黄飞鸿系列经典之作，展现了清末民初武术家的爱国情怀与英雄气概。精彩的武术设计和深厚的家国情怀，让这部影片成为不朽的经典。',
    tags: ['动作', '武侠', '历史'],
    views: 1750000,
    featured: false,
  },
  {
    id: 'v10',
    title: '流浪地球',
    slug: 'liulang-diqiu',
    category: 'kehuan',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20film%20frozen%20Earth%20landscape%20with%20massive%20planet%20engines%20blue%20plasma%20flames%20in%20space%20cinematic%20epic%20scale%20futuristic%20atmosphere%20dramatic%20lighting%20movie%20poster%20style%20grand%20visual&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    duration: '125分钟',
    rating: 8.3,
    quality: '蓝光',
    year: 2019,
    description: '中国科幻电影的里程碑之作，讲述人类带着地球逃离太阳系的壮丽故事。影片以震撼的视觉效果和深沉的亲情主线，开启了中国科幻电影的新纪元。',
    tags: ['科幻', '灾难', '冒险'],
    views: 4500000,
    featured: true,
  },
  {
    id: 'v11',
    title: '无间道',
    slug: 'wujiandao',
    category: 'xuanyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20crime%20thriller%20film%20two%20men%20in%20dark%20suits%20facing%20each%20other%20on%20rooftop%20with%20city%20skyline%20dramatic%20contrast%20lighting%20suspenseful%20atmosphere%20cinematic%20composition%20classic%20police%20undercover%20movie%20poster&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    duration: '101分钟',
    rating: 9.3,
    quality: '蓝光',
    year: 2002,
    description: '华语警匪片的巅峰之作，以精妙的双卧底设定和深刻的人性探讨，创造了一部令人窒息的悬疑经典。剧情环环相扣，表演堪称完美。',
    tags: ['悬疑', '警匪', '经典'],
    views: 3800000,
    featured: false,
  },
  {
    id: 'v12',
    title: '大话西游之大圣娶亲',
    slug: 'dahua-xiyou',
    category: 'xiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20comedy%20film%20monkey%20king%20in%20colorful%20traditional%20costume%20with%20magical%20golden%20staff%20against%20sunset%20desert%20landscape%20romantic%20and%20humorous%20atmosphere%20cinematic%20photography%20classic%20movie%20poster&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    duration: '99分钟',
    rating: 9.2,
    quality: '超清',
    year: 1995,
    description: '一部被时间证明的经典，将西游记改编成一段关于爱情与宿命的奇幻故事。笑中有泪，悲喜交织，影响了一代人的爱情观。',
    tags: ['喜剧', '奇幻', '爱情'],
    views: 4200000,
    featured: true,
  },
];

export const articles = [
  {
    id: 'a1',
    title: '国产经典动作片的黄金时代：1991年必看影片回顾',
    slug: 'guochan-dongzuo-huangjin-shidai',
    category: 'dongzuo',
    thumbnail: 'https://readdy.ai/api/search-image?query=retro%20Chinese%20action%20movies%20collection%20display%20with%20film%20reels%20and%20posters%20nostalgic%201990s%20cinema%20atmosphere%20warm%20vintage%20lighting%20editorial%20photography%20artistic%20composition&width=800&height=450&seq=article-thumb-01&orientation=landscape',
    date: '2026-07-28',
    author: '影评人老王',
    excerpt: '1991年是中国电影史上浓墨重彩的一年，多部经典动作影片在这一年问世。本文将带您回顾那个热血沸腾的年代，重温那些令人难忘的经典之作。',
    content: `1991年，中国电影市场迎来了一个百花齐放的黄金时期。这一年，不仅有实力派导演的精心力作，更有众多优秀演员的精彩演绎。

## 动作片的高光时刻

《龙虎风云》是1991年最具代表性的动作影片之一。影片以紧凑的剧情和精彩的动作设计，展现了九十年代初期国产动作片的制作水准。导演巧妙地将警匪对决与人性探讨相结合，使影片跳脱出单纯的动作片范畴，成为一部具有深度的作品。

## 战争史诗的宏大叙事

《大决战之辽沈战役》作为大决战系列的开篇之作，以恢弘的气势和细腻的人物刻画，再现了解放战争中的关键战役。影片动用了大量实景拍摄和群演，战争场面的震撼力至今令人难忘。

## 港产片的璀璨光芒

《纵横四海》则代表了港产动作片的浪漫主义风格。影片中三位主演的精彩表演，加上精心设计的盗窃场景，使其成为动作片爱好者心中不可替代的经典。

## 时代意义

回顾1991年的国产影片，我们不仅能看到电影技术的进步，更能感受到那个时代电影人的创作热情和艺术追求。这些影片承载了一代人的集体记忆，至今仍然闪耀着不灭的光芒。`,
  },
  {
    id: 'a2',
    title: '从胶片到数字：国产电影画质的进化之路',
    slug: 'jiaopian-dao-shuzi-huazhi-jinhua',
    category: 'jilu',
    thumbnail: 'https://readdy.ai/api/search-image?query=vintage%20film%20camera%20next%20to%20modern%20digital%20cinema%20camera%20evolution%20of%20filmmaking%20technology%20warm%20studio%20lighting%20cinematic%20photography%20editorial%20style%20artistic%20composition&width=800&height=450&seq=article-thumb-02&orientation=landscape',
    date: '2026-07-25',
    author: '技术观察员小张',
    excerpt: '从胶片时代的颗粒质感到如今4K蓝光的极致清晰，国产电影的画质经历了怎样的变革？本文为您梳理国产电影画质发展的完整历程。',
    content: `电影画质的进化史，也是电影技术发展的一面镜子。从早期的黑白胶片到如今的高清数字摄影，每一次技术革新都为观众带来了全新的视觉体验。

## 胶片时代的光影记忆

在胶片时代，电影的质感取决于胶片的种类、曝光控制以及后期冲洗工艺。那个年代的影片虽然清晰度有限，但独特的胶片颗粒感和色彩饱和度，为电影增添了一种难以复制的艺术魅力。

## 数字革命的到来

进入21世纪，数字摄影技术逐渐普及。高清摄像机取代了传统的胶片摄影机，后期制作也从物理剪辑转向了数字非线编。这一转变大大提高了制作效率，也让电影画质有了质的飞跃。

## 蓝光时代的极致体验

蓝光技术的出现，让家庭观影体验达到了前所未有的高度。1080P全高清画质、无损音频编码，使得在家观看电影也能获得接近影院的体验。如今，4K超高清更是将画质推向了新的高峰。

## 展望未来

随着8K技术、HDR和AI画质增强等新技术的发展，国产电影的画质还将不断提升。我们有理由相信，未来的观影体验将更加震撼和沉浸。`,
  },
  {
    id: 'a3',
    title: '华语电影在世界舞台上的崛起与影响',
    slug: 'huayu-dianying-shijie-wutai',
    category: 'jilu',
    thumbnail: 'https://readdy.ai/api/search-image?query=international%20film%20festival%20red%20carpet%20with%20Chinese%20film%20posters%20displayed%20elegant%20ceremony%20atmosphere%20golden%20trophies%20cinematic%20photography%20prestigious%20editorial%20style&width=800&height=450&seq=article-thumb-03&orientation=landscape',
    date: '2026-07-20',
    author: '文化评论员小李',
    excerpt: '从戛纳到奥斯卡，华语电影正在世界舞台上绽放越来越耀眼的光芒。本文探讨华语电影的国际影响力及其背后的文化力量。',
    content: `华语电影的国际征程始于上世纪八十年代，经过几十年的发展，如今已经成为世界电影版图中不可或缺的重要力量。

## 国际电影节的华语声音

从《红高粱》在柏林电影节斩获金熊奖，到《霸王别姬》在戛纳荣膺金棕榈奖，华语电影在国际顶级电影节上屡获殊荣。这些奖项不仅是对电影艺术水平的认可，更是中国文化软实力不断提升的体现。

## 商业电影的全景布局

近年来，以《流浪地球》为代表的国产科幻大片，不仅在票房上取得了巨大成功，更在海外市场引起了广泛关注。中国电影工业的快速成熟，使得国产商业片具备了与国际大片竞争的实力。

## 文化输出的深层价值

电影是文化传播的重要载体。通过华语电影，世界看到了一个真实、立体、全面的中国。功夫片、文艺片、科幻片等不同类型的作品，从多个维度展现了中国文化的魅力。

## 未来的机遇与挑战

在全球化的背景下，华语电影面临着机遇与挑战并存的局面。如何在保持文化特色的同时讲好世界性的故事，是华语电影人需要持续探索的课题。`,
  },
  {
    id: 'a4',
    title: '经典老片修复技术：让时光倒流的魔法',
    slug: 'jingdian-laopian-xiufu-jishu',
    category: 'jilu',
    thumbnail: 'https://readdy.ai/api/search-image?query=film%20restoration%20studio%20with%20professional%20equipment%20technician%20working%20on%20old%20film%20reel%20digital%20monitors%20showing%20before%20and%20after%20comparison%20warm%20technical%20lighting%20editorial%20photography&width=800&height=450&seq=article-thumb-04&orientation=landscape',
    date: '2026-07-15',
    author: '修复工程师大刘',
    excerpt: '许多经典老片因年代久远，胶片出现褪色、划痕等问题。现代数字修复技术如何让这些珍贵的影像重获新生？',
    content: `电影修复是一项结合技术与艺术的工作。每一部经典老片的"复活"，背后都凝聚着修复团队的大量心血。

## 为什么需要修复

老电影的胶片在长期保存过程中，会受到温度、湿度、光线等因素的影响，出现褪色、霉变、划痕等问题。如果不及时修复，这些珍贵的影像资料将永远消失。

## 数字修复的核心技术

现代数字修复技术主要包括物理清洁、高精度扫描、数字画面修复、色彩校正和声音修复等环节。修复师需要逐帧检查画面，手动清除划痕和污点，同时保持影片原有的艺术风格。

## AI辅助修复的突破

近年来，人工智能技术的引入大大提高了修复效率。AI可以自动识别画面中的瑕疵并进行智能修复，但对于细节的把控，仍然需要专业修复师的人工干预。

## 修复的意义

每一部修复后的经典影片，都是一份珍贵的文化遗产。通过修复技术，我们不仅能够重温经典，更能让优秀的电影文化代代相传。`,
  },
];